import React, {useContext} from "react"

// context 
import {ShopContext} from "../../../context"

// components
import {Warning} from "./../../controls"

// styling
import "./Validation.scss"

function Validation({stepName}) {
  // context
  let shop = useContext(ShopContext)

  // validation message
  let cartValidation = shop.cartValidation
  let isValid = true
  let message =  null
  switch(stepName) {
    case "cart":
      isValid = cartValidation.activities
      if(!isValid) {
        message = cartValidation.activitiesMessage
      }
      break
    case "payment":
      isValid = cartValidation.payment
      if(!isValid) {
        message = cartValidation.paymentMessage
      }
      break
    case "personalize":
      isValid = cartValidation.personalization
      if(!isValid) {
        message = cartValidation.personalizationMessage
      }
      break
    case "confirm":
      isValid = cartValidation.valid
      message = `Die Bestellung kann nicht abgeschlossen werden: ${cartValidation.errors.join(', ')}`
      break
    default:
      break
  }

  if(!isValid) {
    return (
      <div id="v-checkout-validation">
        <Warning text={message} />
      </div>
    )
  }
  else {
    return null
  }
  
}

export default Validation